<template>
  <div class="landing w-100">
    <b-container class="banner-corporate">
      <b-row class="justify-content-center">
        <b-col cols="10" lg="8">
          <div class="flex-section d-flex align-items-center align-content-center mb-4">
            <div class="img">
              <img
                src="https://images.vexels.com/img/landings/isotipo.png"
                :alt="$t('enterprise.index.banner.vexelsIconAlt')"
                loading="lazy"
              />
            </div>
            <div>
              <h1 class="principal-title font-weight-light">
                <span class="font-weight-bold">{{ $t('enterprise.index.banner.vexels') }}</span>
                {{ $t('enterprise.index.banner.enterprise') }}
              </h1>
              <h2 class="principal-sub-title">
                <span class="font-weight-bold">{{
                  $t('enterprise.index.banner.designSolutions')
                }}</span>
                <br />{{ $t('enterprise.index.banner.forInnovators') }}
              </h2>
            </div>
          </div>
          <div class="video-section">
            <Video
              :options="playerOptions"
              classes="video-player-box video"
              :playsinline="true"
            ></Video>
          </div>
          <div class="flex-section align-items-center align-content-center who">
            <div class="title">
              <p class="sub">
                {{ $t('enterprise.index.banner.whos') }}<br />
                {{ $t('enterprise.index.banner.vexelsQ') }}
              </p>
            </div>
            <div class="who-p">
              <p>
                {{ $t('enterprise.index.banner.whosVexelsAnswer') }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="how-we-do-it">
      <h2 class="title text-center font-weight-lighter">
        {{ $t('enterprise.index.howWeDoIt.title') }}
      </h2>
      <img
        src="https://cdn.vexels.com/img/how-we-do-it.png"
        data-srcset="https://cdn.vexels.com/img/how-we-do-it.png 1x, 
                     https://cdn.vexels.com/img/how-we-do-it@2x.png 2x"
        :alt="$t('aboutUs.main.section.howWeDoItAlt')"
        class="w-100"
        loading="lazy"
      />
    </b-container>

    <b-container class="whos-vexels">
      <h2 class="title text-center font-weight-lighter">
        {{ $t('enterprise.index.whosVexels.title') }}
      </h2>
      <WhoBlock
        v-for="(item, index) in whoBlocks"
        :key="index"
        :url-img="item.img"
        :icon="item.icon"
        :icon-color="item.iconColor"
        :title="item.title"
        :sub-title="item.subTitle"
        :content="item.content"
        :left="item.left"
      />
    </b-container>

    <section class="online-design d-flex align-items-center">
      <b-row class="w-100 m-0 justify-content-center">
        <b-col cols="10" sm="8" md="6" lg="5" xl="4" class="text-light text-center">
          <h2 class="title mb-5">
            {{ $t('enterprise.index.onlineDesign.title') }}
          </h2>
          <p>
            {{ $t('enterprise.index.onlineDesign.text') }}
          </p>
        </b-col>
      </b-row>
    </section>

    <TrustedBy class="trusted-featured-container" />
    <FeaturedIn class="trusted-featured-container" />
    <LetsChat />
  </div>
</template>

<script>
import WhoBlock from '@/components/Enterprise/WhoBlock';
import TrustedBy from '@/components/Common/TrustedBy';
import LetsChat from '@/components/Common/LetsChat';
import FeaturedIn from '@/components/Common/FeaturedIn';
import Video from '@/components/Common/Video';

export default {
  name: 'Enterprise',
  nuxtI18n: {
    paths: {
      en: '/enterprise',
      de: '/das-unternehmen',
      es: '/corporativa',
      pt: '/corporativo'
    }
  },
  components: {
    LetsChat,
    WhoBlock,
    TrustedBy,
    FeaturedIn,
    Video
  },
  data() {
    return {
      playerOptions: {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
          }
        ],
        poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
      },
      whoBlocks: [
        {
          left: true,
          icon: 'hottest',
          iconColor: '#3f80f1',
          title: 'enterprise.index.whosVexels.blockTitle1',
          subTitle: 'enterprise.index.whosVexels.blockSubtitle1',
          content: 'enterprise.index.whosVexels.blockContent1',
          img: 'https://cdn.vexels.com/img/in-house.png'
        },
        {
          left: false,
          icon: 'request',
          iconColor: '#3f80f1',
          title: 'enterprise.index.whosVexels.blockTitle2',
          subTitle: 'enterprise.index.whosVexels.blockSubtitle2',
          content: 'enterprise.index.whosVexels.blockContent2',
          img: 'https://cdn.vexels.com/img/marketing-grid.png'
        },
        {
          left: true,
          icon: 'online-editor',
          iconColor: '#3f80f1',
          title: 'enterprise.index.whosVexels.blockTitle3',
          subTitle: 'enterprise.index.whosVexels.blockSubtitle3',
          content: 'enterprise.index.whosVexels.blockContent3',
          img: 'https://cdn.vexels.com/img/dev-grid.png'
        }
      ]
    };
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>
<style lang="scss" src="./styles.scss" scoped></style>
<style lang="scss">
.banner-corporate {
  .video-section {
    text-align: center;
    margin-top: 40px;
    width: 700px;
    margin: auto;
    transition: width 0.5s, height 0.5s;
    @include xl {
      width: 100%;
    }
    @include md {
      height: 250px;
      padding: 0;
    }
    .video,
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
